<template>
  <div>
    <div class="dialog-container">
      <el-form
        ref="form"
        :model="searchForm"
        label-width="85px"
        label-position="left"
        @submit.prevent.native
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('messages.lblClient')">
              <idc-input
                v-model="searchForm.custHnglNm"
                @keyup.native.enter="onChange()"
                size="medium"
                :placeholder="$t('messages.plInput')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('messages.lblServiceNumber')">
              <div class="input-icon">
                <idc-input
                  v-model="searchForm.svcNo"
                  @keyup.native.enter="onChange()"
                  size="medium"
                  :placeholder="$t('messages.plInput')"
                />
                <el-button type="search" size="medium" @click="onChange">
                  <i class="icon-MagnifyingGlass" />
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <!-- <div style="height:500px; overflow-y:auto;"> -->
            <idc-list
              :tableHeader="tableHeader"
              :tableData="tableData"
              @clickRow="clickRow"
              :height="290"
              :row-class-name="tableRowClassName"
            >
              <infinite-loading
                slot="append"
                ref="infiniteLoad"
                spinner="waveDots"
                @infinite="infiniteScroll"
              >
                <div slot="no-results"></div>
                <div slot="no-more"></div>
              </infinite-loading>
            </idc-list>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="com-detail">
      <span>{{ $t("messages.txtStopUser") }}</span>
    </div>
    <!-- <div class="dialog-footer align-r">
      <el-button type="primary" size="medium" @click="modalselect">{{
        $t("messages.plSelectOp")
      }}</el-button>
    </div> -->
  </div>
</template>

<script>
import IdcInput from "@/components/common/IdcInput";
import IdcList from "@/components/common/IdcList";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    IdcInput,
    IdcList,
    InfiniteLoading,
  },
  props: {
    changeHandler3: {
      type: Boolean,
      default: false,
    },
    idcCd: {
      type: String,
      default: "",
    },
  },
  watch: {
    changeHandler3() {
      if (this.changeHandler3) {
        this.onChange();
      }
    },
  },
  data() {
    return {
      searchForm: {
        custHnglNm: "",
        custId: "",
      },
      tableHeader: [
        {
          prop: "rn",
          label: "No",
          width: 46.6,
        },
        {
          prop: "custHnglNm",
          label: "고객사",
          width: 160,
        },
        {
          prop: "svcTypeCdNm",
          label: "서비스",
          width: 140,
        },
        {
          prop: "adtnSvc",
          label: "부가서비스",
          width: 116.5,
        },
        {
          prop: "svcNo",
          label: "서비스번호",
          width: 116.5,
        },
        {
          prop: "svcContId",
          label: "서비스계약ID",
          width: 130,
        },
        {
          prop: "billContId",
          label: "서비스청구ID",
          width: 120,
        },
        {
          prop: "svcSttusCdHnglNm",
          label: "서비스상태",
          width: 120,
        },
        {
          prop: "firstOpnDt",
          label: "개통완료일",
          width: 120,
        },
        {
          prop: "lastChgDt",
          label: "변경완료일",
          width: 120,
        },
        {
          prop: "trmnDt",
          label: "해지완료일",
          width: 120,
        },
        {
          prop: "regrNm",
          label: "등록자",
          width: 120,
        },
        {
          prop: "regDt",
          label: "등록일시",
          width: 120,
        },
      ],
      tableData: [],
      count: 10,
      pageInfo: {
        curPage: 1,
        startIndex: 0,
        lastIndex: 10,
        pageListSize: 10,
        totalListSize: 0,
      },
    };
  },
  mounted() {
    //this.getSvcContList();
  },
  methods: {
    /* modalselect() {
      this.$emit("modalselect");
    }, */
    tableRowClassName({ row }) {
      if (row.svcSttusCd != '2449') { 
        return "is-warning";
      }
    },
    getSvcContList() {
      return this.$BIZ_SERVICE
          .post(this.$API_URLS.Cus.getCustSvcList , {
            curPage: this.pageInfo.curPage,
            custHnglNm : this.searchForm.custHnglNm,
            isPaging: true,
            idcCd: this.idcCd,
            svcNo: this.searchForm.svcNo,
          })
          .then(response => {
            const resData = response.data.resData;
            
            if (resData.list.length > 0) {
              this.pageInfo.curPage++;

              const list = resData.list;
              const tblData = list.map((data) => {
                //부가서비스가 MSP, 보안 모두 있는지 체크
                if (data.adtnSvcMspCnt > 0 && data.adtnSvcSecCnt > 0) {
                   data.adtnSvc =
                    data.adtnSvc || "" + "MSP(" + data.adtnSvcMspCnt + ") "  + "보안(" + data.adtnSvcSecCnt + ")";
                }else{ //부가서비스가 둘 중에 하나만 있다면
                  if (data.adtnSvcMspCnt > 0) {
                    data.adtnSvc =
                      data.adtnSvc || "" + "MSP(" + data.adtnSvcMspCnt + ")";
                  }
                  if (data.adtnSvcSecCnt > 0) {
                    data.adtnSvc =
                      data.adtnSvc || "" + "보안(" + data.adtnSvcSecCnt + ")";
                  }
                }
                return data;
              });
              
              this.tableData = this.tableData.concat(tblData);
              this.pageInfo.totalListSize = resData.page.totalListSize;
              
              return Promise.resolve("loaded");
            } else {
              return Promise.resolve("complete");
            }
          })
          .catch(error => {
            console.log(error);
          });
    },
    clickRow(col, row) {
      this.$emit("modalSelect", row);
    },
    infiniteScroll($state) {
      setTimeout(() => {
        this.getSvcContList().then((status) => {
          if (status === "loaded") {
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      }, 500);
    },
    onChange: function (val) {
      this.tableData = [];
      //this.count = val;
      this.pageInfo.curPage = 1;
      //this.pageInfo.startIndex = 0;
      //this.pageInfo.lastIndex = val;
      this.$refs.infiniteLoad.stateChanger.reset();
    },
    resetModal() {
      this.tableData = [];
      //this.count = val;
      this.pageInfo.curPage = 1;
      //this.pageInfo.startIndex = 0;
      //this.pageInfo.lastIndex = val;
      this.$refs.infiniteLoad.stateChanger.reset();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-table__body-wrapper {
    overflow: auto;
    height: calc(100vh - 370px);
  }
}
.select-popup {
  height: 300px;
  width: 780px;
}
.input-icon {
  display: flex;
  align-items: center;
  gap: 5px;
}
.com-detail {
  color: $--color-gray;
}
.ly-table {
  margin-top: -20px;
}
.sub-footer {
  padding: 10px 0;
}
.flex-col {
  display: flex;
  justify-content: space-between;
  gap: 5px;
  padding-top: 5px;
}
::v-deep {
  .el-table .cell {
    overflow-wrap: break-word;
    white-space: pre;
  }
  .is-warning{
    background-color: #ffedee;
  }
}
</style>
